import {
  DrawerBookingDataType,
  DrawerSliceInitial,
  TimeSlotType,
} from "@models/services/drawer";
import { CaseReducer, createSlice, PayloadAction } from "@reduxjs/toolkit";

import bookingSlice from "./booking.slice";

const EMPTY_DRAWER_BOOKING_DATA: DrawerBookingDataType = {
  drawerSelectedTime: "",
  drawerTime: "",
  resourceId: "",
  slot: "",
};

const initialState: DrawerSliceInitial = {
  drawerBookingData: EMPTY_DRAWER_BOOKING_DATA,
  openPercent: 0,
  resourceTimeSlots: [],
  showBookingDrawer: false,
};

type DrawerSliceReducer<Payload> = CaseReducer<
  DrawerSliceInitial,
  PayloadAction<Payload>
>;

const setDrawerBookingData: DrawerSliceReducer<DrawerBookingDataType> = (
  state,
  action
) => {
  state.drawerBookingData = action.payload;
};

const setShowBookingDrawer: DrawerSliceReducer<boolean> = (state, action) => {
  state.showBookingDrawer = action.payload;
};

const setOpenPercent: DrawerSliceReducer<number> = (state, action) => {
  state.openPercent = action.payload;
};

const setResourceTimeSlot: DrawerSliceReducer<TimeSlotType> = (
  state,
  action
) => {
  state.resourceTimeSlots = action.payload;
};

const removeDrawerBookingState: DrawerSliceReducer<null> = state => {
  state.drawerBookingData = EMPTY_DRAWER_BOOKING_DATA;
  state.showBookingDrawer = false;
  state.resourceTimeSlots = [];
};

export const drawerSlice = createSlice({
  extraReducers: builder => {
    builder
      .addCase(bookingSlice.actions.changeSelectedDate, state => {
        state.drawerBookingData = EMPTY_DRAWER_BOOKING_DATA;
        state.showBookingDrawer = false;
      })
      .addCase(bookingSlice.actions.flush, state => {
        state.drawerBookingData = EMPTY_DRAWER_BOOKING_DATA;
        state.showBookingDrawer = false;
        state.resourceTimeSlots = [];
      });
  },
  initialState,
  name: "drawer",
  reducers: {
    removeDrawerBookingState,
    setDrawerBookingData,
    setOpenPercent,
    setResourceTimeSlot,
    setShowBookingDrawer,
  },
});

export default drawerSlice;
